import { Component } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import * as saveAs from 'file-saver';
import { debounceTime, distinctUntilChanged, map, Observable, startWith } from 'rxjs';
import { DatatableConfig } from 'src/app/config/DatatableConfig';
import { FiltrosExclusion, ICategoriaAsignatura, ISeccion, ISedes, ISiglaAsignatura } from 'src/app/interfaces/exclusion-asignatura';
import { IResBuscaListadoReportes, IResGeneraSolicitudReporte } from 'src/app/interfaces/reporte-ponderaciones-individuales';
import { IListaPeriodos } from 'src/app/interfaces/utils';
import { ExclusionService } from 'src/app/services/exclusion-asignatura/exclusion-asignatura';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { ReportePonderacionesIndividualesService } from 'src/app/services/reporte-ponderaciones-individuales/reporte-ponderaciones-individuales.service';
import { UtilsService } from 'src/app/services/utils/utils.service';

@Component({
  selector: 'app-view-reporte-ponderaciones-individuales',
  templateUrl: './view-reporte-ponderaciones-individuales.component.html',
  styleUrls: ['./view-reporte-ponderaciones-individuales.component.scss']
})
export class ViewReportePonderacionesIndividualesComponent {
  dtOptionsDp: DataTables.Settings | any = { ...DatatableConfig.dtExclusionAsignaturas }
  parametrosFormDp = this.formBuilder.group({
    anyo: ['0', [Validators.required]],
    periodo: ['0', [Validators.required]],
    sede: ['0'],
    tipoAsignatura: ['0', [Validators.required]],
    asignatura: ['', [Validators.required]],
    seccion: ['']
  })
  listaAnyosDp: Array<number> = []
  listaPeriodosDp: any = [];
  listaSedesDp: any = [];
  listaTipoAsignaturaDp: any = [];
  listaAsignaturaDp: any = [];
  listaSeccionDp: any = [];
  listaDatosDp: any = [];
  filtrosExclusionDp: FiltrosExclusion = new FiltrosExclusion();

  errorDp: string = "";
  mensajeExitoDp: string = "";

  searchAsignaturaFormDp = new FormControl('')
  searchSeccionFormDp = new FormControl('');
  filteredAsignaturaDp: Observable<Array<any>>
  filteredSeccionDp: Observable<Array<any>>;
  submittedDp: boolean = false;
  tieneErroresDp: any = {};
  tableRender: boolean = false;
  rolDaraCentralDp: boolean = false

  currentTabDp: string = 'individual'
  alertaExitoDp: string = ''
  alertaErrorDp: string = ''

  listaReportesDp: any = []
  timeoutRefreshTableDp: any

  constructor(
    private utilsService: UtilsService,
    private _perfilamiento: PerfilamientoService,
    private exclusionService: ExclusionService,
    private formBuilder: FormBuilder,
    private _reportePonderacionesIndividuales: ReportePonderacionesIndividualesService
  ) {
    this.filteredAsignaturaDp = this.searchAsignaturaFormDp.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', "asignatura")),
    );
    this.filteredSeccionDp = this.searchSeccionFormDp.valueChanges.pipe(
      startWith(''),
      map(value => this._filter(value || '', "seccion")),
    )
    this.searchAsignaturaFormDp.valueChanges.pipe(
      debounceTime(400),
      distinctUntilChanged()
    )
      .subscribe(res => {
        if (typeof res === 'object') {
          this.listaSeccionDp = [];
          let id = this.obtenerId(res);
          this.getListaSeccion(this.filtrosExclusionDp.sedeId, this.filtrosExclusionDp.tipoAsignaturaId, id);
        } else {
          this.listaSeccionDp = [];
          this.filteredSeccionDp = this.searchSeccionFormDp.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '', "seccion")),
          )
        }
      })

    const userData = this._perfilamiento.getUsuario()
    if (userData.nombreRol === 'R_DARA_C') {
      this.rolDaraCentralDp = true
    }
  }

  ngOnInit(): void {
    this.dtOptionsDp = { ...DatatableConfig.dtExclusionAsignaturas }
    this.dtOptionsDp.order = [[0, 'desc']]
    this.dtOptionsDp.searching = true
    this.dtOptionsDp.dom = "<'pull-left'f>t<'bottom'>lp"
    this.getListaAnyos()
    this.getListaTipoAsignatura()
  }

  ngOnDestroy() {
    clearTimeout(this.timeoutRefreshTableDp)
  }

  private _filter(value: string, solicitante: string): string[] {
    if (typeof value != 'string') {
      return [];
    }
    const filterValue = this._normalizeValue(value);
    if (solicitante == "asignatura") {
      return this.listaAsignaturaDp.filter((asignatura: { id: number, codigo: string }) => this._normalizeValue(asignatura?.codigo)?.includes(filterValue));
    } else {
      return this.listaSeccionDp.filter((seccion: { id: number, codigo: string }) => this._normalizeValue(seccion?.codigo)?.includes(filterValue));
    }

  }

  private _normalizeValue(value: string): string {
    return value?.toLowerCase()?.normalize("NFD")?.replace(/[\u0300-\u036f]/g, '');
  }

  getListaAnyos() {
    this.utilsService.obtenerListaAnhos().subscribe(
      (res: any) => {
        if (res.error != null) {
          this.errorDp = res.error;
          this.limpiarMensajes();
        } else {
          this.listaAnyosDp = res.anyos;
        }
      }
    )
  }

  getListaSedes() {
    let user = this._perfilamiento.getUsuario();
    let userId = user.usuarioId;
    if (this.filtrosExclusionDp.anyo != 0 && this.filtrosExclusionDp.periodoId != 0) {
      this.exclusionService.getSedes(userId, this.filtrosExclusionDp.anyo, this.filtrosExclusionDp.periodoId).subscribe(
        {
          next: (res: ISedes) => {
            this.listaSedesDp = res.sedes;
          }
        }
      );
    }
  }

  getListaPeriodos(): void {
    if (this.filtrosExclusionDp.anyo != 0) {
      this.filtrosExclusionDp.periodoId = 0;
      this.utilsService.obtenerListaPeriodos(this.filtrosExclusionDp.anyo).subscribe({
        next: (res: IListaPeriodos) => {
          this.listaPeriodosDp = res.periodos;
        },
        error: error => {
          this.limpiarMensajes();
        }
      })
    }
  }

  getListaTipoAsignatura(sedeId?: number): void {
    this.filtrosExclusionDp.tipoAsignaturaId = 0;
    this.filtrosExclusionDp.asignaturaId = 0;
    this.listaTipoAsignaturaDp = [];
    this.listaAsignaturaDp = [];
    this.searchAsignaturaFormDp.setValue("");
    this.searchSeccionFormDp.setValue("");

    this.exclusionService.getCategoriasAsignatura().subscribe({
      next: (res: ICategoriaAsignatura) => {
        this.listaTipoAsignaturaDp = res.categoriaAsignaturaDTOList;
      }
    })
  }

  getListaAsignatura(sedeId: number, tpoAsignaturaId: number): void {
    if (this.filtrosExclusionDp.anyo != 0 && this.filtrosExclusionDp.periodoId != 0) {
      this.filtrosExclusionDp.asignaturaId = 0;
      this.filtrosExclusionDp.seccionId = 0;
      this.listaAsignaturaDp = [];
      this.listaSeccionDp = [];

      this.searchAsignaturaFormDp.setValue("");
      this.searchSeccionFormDp.setValue("");
      this.exclusionService.getSiglasAsignatura(this.filtrosExclusionDp.anyo, this.filtrosExclusionDp.periodoId, sedeId, tpoAsignaturaId).subscribe({
        next: (res: ISiglaAsignatura) => {
          this.listaAsignaturaDp = res.asignaturas;
          this.filteredAsignaturaDp = this.searchAsignaturaFormDp.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '', "asignatura")),
          );
        }
      })
    }
  }

  getListaSeccion(sedeId: number, tpoAsignaturaId: number, asignaturaId: number): void {
    if (this.filtrosExclusionDp.anyo != 0 && this.filtrosExclusionDp.periodoId != 0) {
      this.listaSeccionDp = [];
      this.filtrosExclusionDp.seccionId = 0;
      this.searchSeccionFormDp.setValue("");
      this.exclusionService.getSeccion(this.filtrosExclusionDp.anyo, this.filtrosExclusionDp.periodoId, sedeId, tpoAsignaturaId, asignaturaId).subscribe({
        next: (res: ISeccion) => {
          this.listaSeccionDp = res.secciones;
          this.filteredSeccionDp = this.searchSeccionFormDp.valueChanges.pipe(
            startWith(''),
            map(value => this._filter(value || '', "seccion")),
          );
        }
      })
    }
  }

  obtenerId(objeto: any): number {
    return objeto.id;
  }

  filtrosConError(): boolean {
    let error = false;
    if (typeof this.searchAsignaturaFormDp.value === 'object') {
      this.filtrosExclusionDp.asignaturaId = this.obtenerId(this.searchAsignaturaFormDp.value)
    } else if ( this.searchAsignaturaFormDp.value !== '' && this.obtenerId(this.searchAsignaturaFormDp.value) === undefined ) {
      this.tieneErroresDp['asignatura'] = true;
      error = true;
    }
    if (typeof this.searchSeccionFormDp.value === 'object') {
      this.filtrosExclusionDp.seccionId = this.obtenerId(this.searchSeccionFormDp.value)
    } else {
      this.filtrosExclusionDp.seccionId = 0;
    }
    if (this.filtrosExclusionDp.anyo == 0) {
      this.tieneErroresDp['anyo'] = true;
      error = true;
    }
    if (this.filtrosExclusionDp.periodoId == 0) {
      this.tieneErroresDp["periodo"] = true;
      error = true;
    }

    if (!this.rolDaraCentralDp && this.filtrosExclusionDp.sedeId == 0) {
      this.tieneErroresDp["sede"] = true;
      error = true;
    }
    if ( typeof this.searchAsignaturaFormDp.value !== 'object' && this.searchAsignaturaFormDp.value === '' ) {
      this.filtrosExclusionDp.asignaturaId = 0
    }
    return error
  }

  generarReporte(): void {
    this.submittedDp = true
    let error = this.filtrosConError()
    if ( !error ) {
      let cstmFiltros: any = { ...this.filtrosExclusionDp }
      delete cstmFiltros.tipoAsignaturaId
      cstmFiltros.catAsignaturaId = this.filtrosExclusionDp.tipoAsignaturaId
      this._reportePonderacionesIndividuales.postGeneraSolicitudReporte(cstmFiltros).subscribe(
        (res: IResGeneraSolicitudReporte) => {
          if ( res.error !== null ) {
            this.alertaErrorDp = res?.error?.mensaje ?? 'Hubo un error en los servicios.'
          } else {
            this.alertaErrorDp = ''
            this.alertaExitoDp = 'El reporte ha sido generado exitosamente.'
            this.buscarReportes()
            this.fnAutoRefresh()
          }
          setTimeout(() => {
            this.alertaErrorDp = ''
            this.alertaExitoDp = ''
          }, 13000);
        }
      )
    }
  }

  fnAutoRefresh(): void {
    clearTimeout(this.timeoutRefreshTableDp)
    this.timeoutRefreshTableDp = setTimeout(() => {
      if ( !this.filtrosConError() ) {
        this.buscarReportes()
      } else {
        clearTimeout(this.timeoutRefreshTableDp)
      }
    }, (1000 * 60));
  }

  buscarReportes(): void {
    this.tableRender = false
    this.submittedDp = true

    if (!this.filtrosConError()) {
      this.listaReportesDp = []
      let cstmFiltros: any = { ...this.filtrosExclusionDp }
      delete cstmFiltros.tipoAsignaturaId
      cstmFiltros.catAsignaturaId = this.filtrosExclusionDp.tipoAsignaturaId
      this._reportePonderacionesIndividuales.postBuscaListadoReportes(cstmFiltros).subscribe(
        (res: IResBuscaListadoReportes) => {
          this.listaReportesDp = res.solicitudes
          this.tableRender = true
          this.fnAutoRefresh()
        }
      )
    }
  }

  obtenerReporte(idSolicitud: number): void {
    this._reportePonderacionesIndividuales.getReporteBytes(idSolicitud).subscribe(
        async (res: any) => {
        const contentDispositionHeader = res?.headers?.get('Content-Disposition')
        const fileName = contentDispositionHeader?.split(';')[1]?.trim()?.split('=')[1]
        const bufferPromise = await res?.body.arrayBuffer();
        const csvData = new Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), bufferPromise], {type: "text/plain;charset=utf-8"});
        saveAs(csvData, fileName?.replace(/"/g, '') ?? 'reportePonderacionesIndividuales.csv')
      }
    )
  }

  limpiarMensajes() {
    setTimeout(() => {
      this.errorDp = '';
      this.mensajeExitoDp = "";
    }, 15000);
  }

  limpiarFiltros(): void {
    this.filtrosExclusionDp = new FiltrosExclusion();
    this.listaAsignaturaDp = [];
    this.listaPeriodosDp = [];
    this.listaSeccionDp = [];
    this.searchAsignaturaFormDp.setValue("");
    this.searchSeccionFormDp.setValue("");
    this.resetearValidacion();
    this.tableRender = false;
    this.listaDatosDp = [];
  }
  resetearValidacion() {
    this.submittedDp = false;
    this.tieneErroresDp["anyo"] = false;
    this.tieneErroresDp["periodo"] = false;
    this.tieneErroresDp["sede"] = false;
    this.tieneErroresDp["tipoAsignatura"] = false;
    this.tieneErroresDp["asignatura"] = false;
  }
  displayFnAsignatura(asignatura: any): string {
    return asignatura?.codigo ? asignatura.codigo.replace(/\w\S*/g, (w: string) => (w.replace(/^\w/, (c) => c.toUpperCase()))) : '';
  }
  displayFnSeccion(seccion: any): string {
    return seccion?.codigo ?? '';
  }
}
